import { render, staticRenderFns } from "./InpatientEdit.vue?vue&type=template&id=2cc109c1"
import script from "./InpatientEdit.vue?vue&type=script&lang=js"
export * from "./InpatientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports